export default __webpack_public_path__ + "static/media/blog-two.e89b334b.png";